import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const getAllRateSchedules = {
  name: 'getAllRateSchedules',
  state: {
    data: [],
    loading: false,
    error: '',
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
      };
    },

    getReceived(state, payload) {
      const rateScheduleData = payload.data.map(item => ({
        id: item.id,
        name: item.name,
        playlistTime: item.totalPlaylistTime,
        numberOfZones: item.noOfZones,
      }));
      return {
        ...state,
        data: rateScheduleData,
        loading: false,
        error: '',
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async allRateSchedules(isDefault = true) {
      try {
        this.getRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const url = `savvy/rate-schedule/lookup/${userInfo.org_id}?isDefault=${isDefault}`;
        const response = await http.get(url);
        if (response && response.data) {
          this.getReceived({
            data: response.data.data,
          });
        }
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
    async allRateSchedulesbyDisplayId(id) {
      try {
        if (id) {
          this.getRequested();
          const url = `savvy/rate-schedule/lookupbyDisplay/${id}`;
          const response = await http.get(url);
          if (response && response.data) {
            this.getReceived({
              data: response.data.data,
            });
          }
        }
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default getAllRateSchedules;

